import { INITIAL_STATE } from './constants'

export default {
  setPayrolls(state, payload) {
    state.payrolls = payload
  },
  setActivePayroll(state, payload) {
    state.activePayroll = payload
  },
  setMetrics(state, payload) {
    state.metrics = payload
  },
  setCalculations(state, payload) {
    state.calculations = payload
  },
  setAdjustments(state, payload) {
    state.adjustments = payload
  },
  setAdjustmentsShifts(state, { adjustment_id, shifts }) {
    state.adjustmentsShifts[adjustment_id] = shifts
  },
  SET_ADJUSTMENTS_SHIFTS_LOADING(state, { adjustment_id, loading }) {
    state.adjustmentsShiftsLoading[adjustment_id] = loading
  },
  setPayPeriods(state, payload) {
    state.payPeriods = payload
  },
  setShifts(state, { type, shifts }) {
    state.shifts[type] = shifts
  },
  setPaymentRequests(state, payload) {
    state.paymentRequests = payload
  },
  setValidationAssociates(state, payload) {
    state.validationAssociates = payload
  },
  setSignedAssociates(state, payload) {
    state.signedAssociates = payload
  },
  setUnsignedAssociates(state, payload) {
    state.unsignedAssociates = payload
  },
  setAssociateShifts(state, payload) {
    state.associateShifts = payload
  },
  setAssociatePayments(state, payload) {
    state.associatePayments = payload
  },
  setAssociateCalculations(state, payload) {
    state.associateCalculations = payload
  },
  setScopePresets(state, payload) {
    state.scopePresets = payload
  },
  setScopePreset(state, payload) {
    state.scopePreset = payload
  },
  setScopeGlobal(state, payload) {
    state.scopeGlobal = payload
  },
  setPremiumPayRules(state, payload) {
    state.premiumPayRules = payload
  },
  setPayCodeMappings(state, payload) {
    state.payCodeMappings = {
      ...state.payCodeMappings,
      ...(payload ?? {})
    }
  },
  resetState(state) {
    Object.assign(state, JSON.parse(JSON.stringify(INITIAL_STATE)))
  }
}
